import React from 'react';

const Weather = ({ min, max, humidity, weather, weatherIcon }) => {
    return (
        <div >
            
            <div className="day text-light">
            <div>Humidity: {humidity}</div>
            <div>Temp: min-{min}/ max-{max}</div>
            <div>weather: {weather}</div>
            <div>weatherIcon: {weatherIcon}</div>
        </div>
        </div>
        
    );
};

export default Weather;